import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  viewBox: "0 0 28.571 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "28.571",
      height: "20",
      fill: "#f28d20",
      rx: "2"
    }, null, -1),
    _createElementVNode("g", { fill: "#fff" }, [
      _createElementVNode("path", { d: "M5.11 8.008c-.648 0-1.238.241-1.689.634.112-.263.322-.478.585-.594v-.237a.935.935 0 0 0-.938-.938H2.55v3.694a2.56 2.56 0 1 0 2.56-2.56M8.437 8.995h1.184v4.132H8.437zM9.594 7.186a.9.9 0 0 0-.25-.17q-.146-.061-.308-.062c-.162-.001-.21.022-.308.062s-.179.098-.25.17-.125.152-.17.25a.79.79 0 0 0 0 .612.825.825 0 0 0 .42.415q.146.062.308.063c.162.001.21-.022.308-.063s.179-.098.25-.17.13-.151.17-.245a.78.78 0 0 0-.17-.862M10.52 7.16h1.183v5.967h-1.184zM12.6 7.16h1.184v5.967h-1.183zM15.84 7.186a.9.9 0 0 0-.251-.17q-.147-.061-.308-.062c-.161-.001-.21.022-.308.062s-.18.098-.25.17-.126.152-.17.25a.79.79 0 0 0 0 .612.825.825 0 0 0 .42.415q.146.062.308.063c.162.001.21-.022.308-.063s.179-.098.25-.17.13-.151.17-.245a.78.78 0 0 0-.17-.862M14.682 8.995h1.184v4.132h-1.184zM20.288 9.026q-.28-.281-.656-.442c-.376-.161-.514-.16-.8-.16q-.396-.002-.75.138a2.1 2.1 0 0 0-.644.397l-.388-.446h-.286v4.614h1.175v-2.64a.9.9 0 0 1 .254-.625.897.897 0 0 1 .634-.255.87.87 0 0 1 .876.88v2.64h1.175v-2.64a2 2 0 0 0-.161-.804 2 2 0 0 0-.429-.657M26.02 8.517h-1.354l-1.756 2.225V7.159h-1.183v5.968h1.183v-.59l.822-1.085.934 1.675h1.353l-1.532-2.685z" })
    ], -1),
    _createElementVNode("path", {
      fill: "#f28d20",
      d: "M6.485 10.567v-.009H3.734v.01a1.376 1.376 0 0 0 2.751 0"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "billink"}) } }